import { render } from "./DeletePrivacyConfig.vue?vue&type=template&id=ec24ac88"
import script from "./DeletePrivacyConfig.vue?vue&type=script&lang=js"
export * from "./DeletePrivacyConfig.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__